import React from "react";
import styles from "../WelcomePage.module.css";
import { Reveal } from "../../../../components/motion";

/**
 * Textos del CMS pueden llegar con tildes descompuestas ("u" + U+0301); Ibrand
 * no trae el acento combinable y el navegador lo pinta con otra fuente (la "ú"
 * se ve rota). NFC las compone en el glifo precompuesto, que Ibrand sí tiene.
 */
const nfc = (text) => (typeof text === "string" ? text.normalize("NFC") : text);

/**
 * @param {object} props
 * @param {object} props.section
 * @param {object} props.reveal
 * @param {function} props.sectionReveal
 */
const LandingHowToPlay = ({ section, reveal, sectionReveal }) => (
  <section
    ref={reveal.ref}
    className={`${styles.howSection} ${sectionReveal(reveal)}`}
    id="como-jugar"
  >
    <div className={styles.sectionInner}>
      <Reveal className={styles.sectionCopyCenter}>
        <h2 className={styles.sectionTitle}>{nfc(section.title)}</h2>
        {section.subtitle?.trim() && (
          <p className={styles.sectionSubtitle}>{nfc(section.subtitle)}</p>
        )}
      </Reveal>
      <ol className={styles.howSteps}>
        {section.steps.map((step) => (
          <li key={step.step_number} className={styles.howStep}>
            <span className={styles.howNumber} aria-hidden="true">
              {step.step_number}
            </span>
            <div className={styles.howCard}>
              <span className={styles.srOnly}>Paso {step.step_number}: </span>
              <h3 className={styles.howCardTitle}>{nfc(step.title)}</h3>
              <p className={styles.howCardDesc}>{nfc(step.description)}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default LandingHowToPlay;
